<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="仓库名称" prop="warehouseName">
              {{ formData.warehouseName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库性质" prop="warehouseType">
              {{ warehouseTypeMap.get(formData.warehouseType) || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="managerType" label="仓库类型">
              {{ managerTypeMap.get(formData.managerType) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属公司" prop="company">
              {{ formData.company }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号" prop="warehouseCode">
              {{ formData.warehouseCode }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库编码" prop="warehouseNo">
              {{ formData.warehouseNo }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省市区" prop="warRegion">
              {{ formData.warRegion }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="warAddress">
              {{ formData.warAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮编" prop="warPostcode">
              {{ formData.warPostcode }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="仓库管理员" prop="managerId" placeholder="请选择仓库管理员">
              {{ formData.managerName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="进出库记录" prop="name">
              <el-table size="mini" stripe border v-loading="loading" :data="tableData">
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属仓库"
                  prop="warehouseName"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="类型" prop="ygType">
                  <template v-slot="{ row }">
                    {{ row.ygType === 'B' ? '入库' : '出库' }}
                  </template>
                </el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="出入库类型" prop="recType">
                  <template v-slot="{ row }">
                    {{ cyRecTypeMap.get(row.recType) }}
                  </template>
                </el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="品种规格"
                  prop="specName"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属客户"
                  prop="userName"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="数量"
                  prop="recQuantity"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="操作时间"
                  prop="ctime"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="记录来源" prop="sourceType">
                  <template v-slot="{ row }">
                    {{ recordSourceTypeMap.get(row.sourceType) }}
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next"
                :total="total" @current-change="loadData">
              </el-pagination>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { managerType, warehouseType } from '@/utils/dict'
export default {
  name: 'WarehouseDetail',
  data() {
    return {
      managerTypeMap: managerType,
      warehouseTypeMap: warehouseType,
      formData: {
        warehouseName: '', // 仓库名称
        warehouseType: '', // 仓库性质1内库2外库
        managerType: '', // 仓库类型1油罐2非油罐
        company: '', // 所属公司
        warehouseCode: '', // 仓库编号
        warRegion: '', // 省市区
        warAddress: '', // 详细地址
        warPostcode: '', // 邮编
        managerId: '' // 仓库管理员
      },
      loading: false,
      tableData: [],
      page: 1,
      total: 0
    }
  },
  computed: {
    warehouseId() {
      return this.$route.query.warehouseId
    }
  },
  created() {
    if (this.warehouseId) {
      this.loadDetails()
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.prodManage.selectLyWareRecByPage, {
        page: this.page,
        size: 10,
        warehouseId: this.warehouseId
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByWarehouseId, {
        params: { warehouseId: this.warehouseId }
      }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
